// export const colors = ['#00B3B4', '#F26A8D', '#023C40', '#FFCAB1', '#634B66', '#C5E6A6', '#F2B7C6', '#93B5C6', '#A675A1', '#9A4C95'];
// export const colors = ['#023C40', '#FFCAB1', '#634B66', '#00B3B4', '#F26A8D', '#C5E6A6', '#F2B7C6', '#93B5C6', '#A675A1', '#9A4C95'];

export const colors = [
  '#008792', '#EB5C80', '#0B1D51', '#4CE0B3',
  '#F79D5C', '#A7ABDD', '#49306B', '#FFCB47',
  '#011627', '#23CE6B'];
